
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getPaginatedOrders",
      resolverType: "query",
      routePath: "/getPaginatedOrders",
      httpMethod: "POST",
    });
  